import React, { useState } from 'react';
import { ApiService } from '../services/api';

const SubscriptionForm = ({ style = {}, buttonStyle = {} }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setMessage('이메일을 입력해주세요.');
      setMessageType('error');
      return;
    }

    if (!validateEmail(email)) {
      setMessage('유효한 이메일 주소를 입력해주세요.');
      setMessageType('error');
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      const result = await ApiService.subscribe(email);
      
      if (result.success) {
        setEmail('');
        setMessage(result.message || '구독 요청이 완료되었습니다! 이메일을 확인해주세요.');
        setMessageType('success');
      } else {
        setMessage(result.error || '구독 처리 중 오류가 발생했습니다.');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('서버 연결에 실패했습니다. 잠시 후 다시 시도해주세요.');
      setMessageType('error');
    }
    
    setIsLoading(false);
  };

  return (
    <div style={{ ...style }}>
      <form onSubmit={handleSubmit}>
        <div style={{ 
          display: 'flex', 
          gap: '15px', 
          justifyContent: 'center', 
          flexWrap: 'wrap',
          marginBottom: message ? '20px' : '0'
        }}>
          <input 
            type="email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="이메일을 입력하세요"
            disabled={isLoading}
            style={{ 
              padding: '15px 20px', 
              fontSize: '16px', 
              border: 'none',
              borderRadius: '8px',
              minWidth: '300px',
              outline: 'none',
              opacity: isLoading ? '0.7' : '1'
            }}
          />
          <button 
            type="submit"
            disabled={isLoading}
            style={{ 
              padding: '15px 30px', 
              fontSize: '16px', 
              backgroundColor: isLoading ? '#ccc' : '#ff6b6b',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontWeight: 'bold',
              ...buttonStyle
            }}
          >
            {isLoading ? '처리 중...' : '무료 구독하기'}
          </button>
        </div>

        {message && (
          <div style={{
            padding: '12px 20px',
            borderRadius: '8px',
            backgroundColor: messageType === 'success' 
              ? 'rgba(76, 175, 80, 0.2)' 
              : 'rgba(244, 67, 54, 0.2)',
            color: messageType === 'success' ? '#4caf50' : '#f44336',
            border: `1px solid ${messageType === 'success' ? '#4caf50' : '#f44336'}`,
            marginTop: '15px',
            textAlign: 'center',
            fontWeight: '500'
          }}>
            {message}
          </div>
        )}
      </form>
    </div>
  );
};

export default SubscriptionForm;
